module.exports = __webpack_public_path__ + "static/media/hubspot.12b73fbd.svg";